import _ from 'lodash';
import axios from 'axios';
import { getAuthToken, getRefreshToken, saveAuthDataToLocalStorage } from '../../utils/Auth/AuthUtils';
import { refresh } from '../authorizationAPI';

let refreshPromise = null;

export const edulaiInstance = axios.create({
  timeout: 30000
});

export function interceptorEjectRequest() {
  _.each(_.keys(edulaiInstance.interceptors.request.handlers), (key) => {
    edulaiInstance.interceptors.request.eject(key);
  });
}

export function setRequestInterceptor() {
  return edulaiInstance.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
}

export function setResponseInterceptor() {
  return edulaiInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalRequest = err.config;
      const status = err.response?.status;

      if ((status !== 401 && status !== 403) || originalRequest._retry) {
        return Promise.reject(err);
      }

      originalRequest._retry = true;

      const refreshToken = getRefreshToken();
      if (!refreshToken) {
        return Promise.reject(err);
      }
      try {
        if (!refreshPromise) {
          refreshPromise = refresh(refreshToken)
            .then(({ data }) => {
              saveAuthDataToLocalStorage(data);
              edulaiInstance.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
              return data.access_token;
            })
            .finally(() => {
              setTimeout(() => {
                refreshPromise = null;
              }, 0);
            });
        }

        const newToken = await refreshPromise;

        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return edulaiInstance(originalRequest);
      } catch (e) {
        return Promise.reject(e);
      }
    }
  );
}

export function setBaseUrl(baseURL) {
  edulaiInstance.defaults.baseURL = baseURL;
}

export function getBaseUrl() {
  return edulaiInstance.defaults.baseURL;
}
